import moment from 'moment'
import {FaCheckCircle, FaTimesCircle} from 'react-icons/fa'
import {format, isValid} from 'date-fns';
import EditItemIcon from "../../../assets/edit-item.svg";
import DeleteItemIcon from "../../../assets/delete-item.svg";


export const ViewEvents = ({
                               data,
                               editHandler,
                               deleteHandler,
                               isLoadingDelete
                           }) => {
    // console.log(data);
    return (
        <div className='table-responsive bg-light p-3 mt-2'>

            <table className='table table-sm table-border events-grid-view-edit'>
                <thead className='border-0'>
                <tr>
                    <th>Created</th>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Category</th>
                    <th>Link</th>
                    <th>Location</th>
                    <th>Confirmed</th>
                    <th>Blocked</th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data && data.data ? (
                    data.data.map((event) => (
                        <tr key={event._id}
                            className={(event.title === '' || event.date === '' || event.link === '') ? 'empty-values' : ''}>
                            <td>{moment(event.createdAt).format('lll')}</td>
                            {/*{                console.log(event)}*/}
                            <td>
                                {isValid(new Date(event.dateStart)) && isValid(new Date(event.dateEnd))
                                    ? format(new Date(event.dateStart), 'yyyy-MM-dd') + ' - ' + format(new Date(event.dateEnd), 'yyyy-MM-dd') + ' | ' + event.time
                                    : 'Invalid date'
                                }
                            </td>

                            <td>{event.title}</td>
                            <td>{event.category}</td>
                            <td>{event.link}</td>
                            <td>{event.glocation}</td>
                            <td>
                                {event.confirmed ? (
                                    <FaCheckCircle className='text-success'/>
                                ) : (
                                    <FaTimesCircle className='text-danger'/>
                                )}
                            </td>
                            <td>
                                {event.blocked ? (
                                    <FaCheckCircle className='text-success'/>
                                ) : (
                                    <FaTimesCircle className='text-danger'/>
                                )}
                            </td>

                            <td>
                                <div className='btn-group'>
                                    <button
                                        className='btn'
                                        onClick={() => editHandler(event)}
                                        data-bs-toggle='modal'
                                        data-bs-target='#eventModal'
                                    >
                                        <img src={EditItemIcon} alt="Edit"
                                             className="icon-img action-icons-img"/>
                                    </button>

                                    <button
                                        className='btn'
                                        onClick={() => deleteHandler(event._id)}
                                        disabled={isLoadingDelete}
                                    >
                                        {isLoadingDelete ? (
                                            <span className='spinner-border spinner-border-sm'/>
                                        ) : (

                                            <img src={DeleteItemIcon} alt="Delete"
                                                 className="icon-img action-icons-img"/>
                                        )}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))) : (
                    // Render an error message when data is undefined or has no data
                    <tr>
                        <td colSpan="8">Error: Failed to fetch event data</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>

    )
}

export default ViewEvents
